// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3_HVZ","inputWrap":"styles_inputWrap__2zlVV","input":"styles_input__1pbxL"};